export const COLOR_CONFIGS = {
  OK: {
    color: '#1F6808',
    backgroundColor: '#DAF6C1',
  },
  OK_VARIANT: {
    color: '#e53a7d',
    backgroundColor: '#F9D4E2',
  },
  WARN: {
    color: '#ff8f00',
    backgroundColor: '#FEF1E0',
  },
  ERROR: {
    color: '#B00020',
    backgroundColor: '#EFCCD2',
  },
  INFO: {
    color: '#0055BC',
    backgroundColor: '#CFF5F6',
  },
  GRAY: {
    color: '#545a69',
    backgroundColor: '#ebeef1',
  },
};
